import { render, staticRenderFns } from "./tklx.vue?vue&type=template&id=67ab6100&scoped=true"
import script from "./tklx.vue?vue&type=script&lang=js"
export * from "./tklx.vue?vue&type=script&lang=js"
import style0 from "./tklx.vue?vue&type=style&index=0&id=67ab6100&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ab6100",
  null
  
)

export default component.exports